import { useEffect } from 'react';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import ContentHeader from '../../components/ContentHeader';
import { MyAssets } from './Components/MyAssets';

import './index.scss';

const EntitiesPage = () => {
  useEffect(() => {
    reportScreen('assets_page');
  }, []);

  return (
    <Page className="assets-page">
      <ContentHeader
        title="My assets"
        subTitle="Track all the residential properties you own, gain powerful insights, and optimize your portfolio’s performance."
      />
      <MyAssets />
    </Page>
  );
};

export default EntitiesPage;
